// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"86":"63980d86","142":"63980d86","281":"63980d86","338":"63980d86","536":"63980d86","622":"63980d86","768":"63980d86","778":"63980d86","893":"63980d86","922":"63980d86","938":"63980d86","975":"63980d86"}[chunkId] + ".chunk.css";
};